import { UserTeamSearchFilterEnum } from '@/shared/types/graphql/globals.v5';

import { useTeamTracksFromV5 } from './use-team-tracks-from-v5';

export const useGetTeamTracksMigration = ({
  organization_slug,
  organization_id,
}: {
  organization_slug: string;
  organization_id: number;
}) => {
  const { teams, loading, totalCount, error } = useTeamTracksFromV5({
    organization_id,
    organization_slug,
    filter: UserTeamSearchFilterEnum.TEAM_SEARCH_FILTER_NOT_COMPLETED,
  });

  return {
    teams,
    totalCountTeams: totalCount,
    loading,
    error,
  };
};
